import { useState, useEffect, useRef, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import { formatAuthError } from '@/lib/authErrors';
import { toast } from '@/components/ui';

export function useResendConfirmation(email: string) {
  const [cooldown, setCooldown] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const resend = useCallback(async () => {
    const { error } = await supabase.auth.resend({ type: 'signup', email });
    if (error) {
      toast.error(formatAuthError(error));
    } else {
      toast.success('Confirmation email resent!');
      setCooldown(60);
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(intervalRef.current!);
            intervalRef.current = null;
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  }, [email]);

  return { resend, cooldown };
}
